import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../../utils/response';
import { Token, UserCode, EmployeeId } from '../../../utils/users';
import { errorResponse } from '../../../utils/response';
import { IsEnglish } from '../../../utils/language';

export function jobTitlesPunch() {
    let url = 'punch/jobTitles?' + objectToQueryString({ userCode: UserCode(), employeeId: EmployeeId(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let jobTitles = response.jobTitles;

                //saveJobTitles(jobTitles);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function sortJobTitle(data) {
    return data.sort(function (a, b) {
        const nameA = IsEnglish() ? a.jobDescriptionEnglish.toLowerCase() : a.jobDescriptionFrench.toLowerCase()
        const nameB = IsEnglish() ? b.jobDescriptionEnglish.toLowerCase() : b.jobDescriptionFrench.toLowerCase()
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

export function sortJobTitleByCode(data) {
    return data.sort(function (a, b) {
        const nameA = a.jobCode
        const nameB = b.jobCode
        if (nameA < nameB) //sort string ascending
            return -1
        if (nameA > nameB)
            return 1
        return 0 //default return value (no sorting)
    });
}

function saveJobTitles(config) {
    localStorage.setItem('punchJobTitles', JSON.stringify(config));
}